import React from "react";
import { Search, X, Loader2 } from "lucide-react";
import { Input } from "@/components/ui/input";
import { Button } from "@/components/ui/button";
import { cn } from "@/lib/utils";

/**
 * Props for {@link ThreadSearchBar}.
 */
interface ThreadSearchBarProps {
  value: string;
  onChange: (value: string) => void;
  isLoading?: boolean;
}

/**
 * Search input for the threads list. Matches against thread name, owner name,
 * opportunity name, and task subjects on the server. Shows an inline spinner
 * while a search request is in flight and a clear button when a term is set.
 * @param props - The component props
 */
export const ThreadSearchBar: React.FC<ThreadSearchBarProps> = ({
  value,
  onChange,
  isLoading = false,
}) => {
  const handleClear = () => {
    onChange("");
  };

  return (
    <div className="relative w-full">
      <Search className="absolute left-3 top-1/2 h-4 w-4 -translate-y-1/2 text-muted-foreground/60" />
      <Input
        type="text"
        placeholder="Search threads..."
        value={value}
        onChange={(e) => onChange(e.target.value)}
        className="pl-9 pr-20 h-8 rounded-md"
      />
      <div className="absolute right-2 top-1/2 -translate-y-1/2 flex items-center gap-1">
        {isLoading && (
          <Loader2 className="h-3 w-3 text-muted-foreground/60 animate-spin" />
        )}
        {value && (
          <Button
            variant="ghost"
            size="sm"
            onClick={handleClear}
            className={cn(
              "h-5 w-5 p-0 hover:bg-muted rounded-full",
              "flex items-center justify-center",
            )}
          >
            <X className="h-3 w-3 text-muted-foreground" />
          </Button>
        )}
      </div>
    </div>
  );
};
